import React, { useState, useEffect } from 'react'
import { Button, Label, Form, Card, Dropdown, Input, Icon, Grid } from 'semantic-ui-react'
import { isMobile } from 'react-device-detect'
import { pageEnum } from '../../Common'
import { useHistory } from 'react-router-dom'
import api from '../../api'
import * as Sentry from '@sentry/react'

const lettingType = [
  { key: pageEnum.LongLets, text: 'Long Lets', value: pageEnum.LongLets },
  { key: pageEnum.ShortLets, text: 'Short Lets', value: pageEnum.ShortLets },
  { key: pageEnum.CommercialLets, text: 'Commercials', value: pageEnum.CommercialLets },
  { key: pageEnum.ResidentialSale, text: 'Residential Sales', value: pageEnum.ResidentialSale },
  { key: pageEnum.CommercialSale, text: 'Commercial Sales', value: pageEnum.CommercialSale },
  { key: pageEnum.Room, text: 'Room', value: pageEnum.Room },
]

const SliderForm = () => {

  const [options, setOptions] = useState({
    propertyTypes: [],
    areas: [],
    locations: [],
    locationsFullData: []
  })
  const [form, setForm] = useState({
    lettingType: 1,
    propertyTypes: [],
    referanceNumber: null,
    minPrice: null,
    maxPrice: null,
    areas: [],
    locations: [],
  })
  const [isSelectLettingType, setIsSelectLettingType] = useState(false)
  const [propertyType, setPropertyType] = useState([])

  const history = useHistory()
  let styling = isMobile ? {} : { position: 'absolute', top: '8%', right: '10%', zIndex: 1 }

  useEffect(() => {
    const load = async () => {
      const o = await api.properties.getFilterOptions()
      if (o?.result /* options.statusCode == 200 */) {
        // setOptions(optionss?.result)
        setPropertyType(o?.result.propertyTypes)
        const propTypes = mapPropertyTypes(o?.result.propertyTypes)
        const areas = mapAreas(o?.result.areas)
        const locations = mapLocations([areas[0]?.value], o?.result.locations)
        setOptions({
          ...options,
          propertyTypes: propTypes,
          areas,
          locations,
          locationsFullData: o?.result.locations
        })
      }
    }

    load()
  }, [])

  useEffect(() => {
    const propTypes = mapPropertyTypes(propertyType)
    setOptions({
      ...options,
      propertyTypes: propTypes,
    })
  }, [form.lettingType])

  const mapPropertyTypes = (data) => {
    let propTypes = []
     data = data.filter(x => x.lettingType == form.lettingType)
    data?.map(type => {
      propTypes.push({ key: type.id.toString(), value: type.id, text: type.name })
    })
    return propTypes
  }

  const mapAreas = (data) => {
    let areas = []
    data?.map(type => {
      areas.push({ key: type.id.toString(), value: type.id, text: type.name })
    })
    return areas
  }

  const mapLocations = (areaIds, data) => {
    let locations = []
    data?.map(type => {
      if (areaIds.indexOf(type.group.id) > -1) {
        locations.push({ key: type.id.toString(), value: type.id, text: type.name, groupid: type.groupId })
      }
    })
    return locations
  }

  const onClick = () => {

    const redirect = (pathName) => {
      history.push({
        pathname: pathName,
        state: { form: form }
      })
    }

    if (form.lettingType === null) {
      setIsSelectLettingType(true)
      return
    }

    switch (form?.lettingType) {
      case pageEnum.LongLets:
        redirect('/long-lets')
        break;
      case pageEnum.ShortLets:
        redirect('/short-lets')
        break;
      case pageEnum.CommercialLets:
        redirect('/commercials')
        break;
      case pageEnum.ResidentialSale:
        redirect('/residential-sales')
        break;
      case pageEnum.CommercialSale:
        redirect('/commercial-sales')
        break;
      case pageEnum.Room:
        redirect('/room')
        break;
      default:
        redirect('/long-lets')
    }
  }

  return (

    <Card style={{ ...styling }}>
      <Card.Content>
        <Form>
          {/* <Form.Field>
            <Grid style={{ margin: 0, padding: 0, width: '100%' }} >
              <Grid.Column width="7" style={{ padding: 0 }}>
                <Button
                  type='button'
                  fluid
                  color="green"
                  basic={type != 'Residential'}
                  onClick={() => setType('Residential')}
                >Residential</Button>
              </Grid.Column>
              <Grid.Column width="7" floated='right' style={{ padding: 0 }}>
                <Button
                  type='button'
                  fluid
                  color="green"
                  basic={type != 'Commercial'}
                  onClick={() => setType('Commercial')}
                >Commercial</Button>
              </Grid.Column>
            </Grid>
          </Form.Field> */}

          <Form.Field required>
            <Dropdown placeholder='Choose Letting Type' fluid selection options={lettingType}
              aria-label="choose-letting-type" 
              value={form.lettingType} onChange={(e, d) => setForm({ ...form, lettingType: d.value })} />
            {isSelectLettingType ? <Label color="red">Please Choose Letting Type </Label> : null}
          </Form.Field>

          <Form.Field>
            <Dropdown placeholder='Choose Multiple Property Types' fluid multiple selection options={options.propertyTypes}
              aria-label="choose-property-types" 
              onChange={(e, d) => setForm({ ...form, propertyTypes: d.value })} />
          </Form.Field>
          <Form.Field>
            <Dropdown placeholder='Choose Area' fluid multiple selection options={options.areas} value={form.areas}
              aria-label="choose-area"
              onChange={(e, { value }) => {
                const locations = mapLocations(value, options.locationsFullData)
                setOptions({ ...options, locations })
                try {
                  let locs = []
                  form?.locations?.map(loc => {
                    const locItem = options.locationsFullData.find(l => l.id == loc)
                    if (locItem == null) {
                      return
                    }
                    if (value?.indexOf(locItem.groupId) > -1) {
                      locs.push(loc)
                    }
                  })
                  setForm({ ...form, locations: locs, areas: value })
                } catch (error) {
                  console.log('error area ', error)
                  Sentry.captureException(error)
                }
              }} />
          </Form.Field>
          <Form.Field>
            <Dropdown placeholder='Choose Multiple Locations' fluid multiple selection options={options.locations} value={form.locations}
              aria-label="choose-location"
              onChange={(e, d) => setForm({ ...form, locations: d.value })} />
          </Form.Field>


          <Form.Field>
            <Grid style={{ margin: 0, padding: 0, width: '100%' }} >
              <Grid.Column width="7" style={{ padding: 0 }}>
                <Input iconPosition='left' type='text' placeholder='min.' onChange={(e, d) => setForm({ ...form, minPrice: d.value })}>
                  <Icon name='euro' />
                  <input />
                </Input>
              </Grid.Column>
              <Grid.Column width="2" style={{ padding: 0, textAlign: 'center', marginTop: 10 }}>to</Grid.Column>
              <Grid.Column width="7" floated='right' style={{ padding: 0 }}>
                <Input iconPosition='left' type='text' placeholder='max.' onChange={(e, d) => setForm({ ...form, maxPrice: d.value })}>
                  <Icon name='euro' />
                  <input />
                </Input>
              </Grid.Column>
            </Grid>
          </Form.Field>
          {/* <Form.Field>
            <Checkbox label='I agree to the Terms and Conditions' />
          </Form.Field> */}

          <Button type='submit' onClick={onClick} fluid color="green">Search</Button>

          {/* <Form.Field>
            <Label sty>
              {isSelectLettingType}
            </Label>
          </Form.Field> */}
        </Form>
      </Card.Content>
    </Card>

  )
}

export default SliderForm
